import request from '@lib/request'

// 获取机构信息
function GetOrgan() {
  return request.get('/institutionAdmin/institution/info').then(result => {
    return result.data
  })
}

// 获取教师列表
function GetTeacherList({
  keyword,
  start,
  rows
}) {
  return request
    .get('/institutionAdmin/teacher/list', {
      params: {
        keyword,
        start,
        rows
      }
    })
    .then(result => {
      return result.data
    })
}
// 查询学生数据
function SearchStudent({
  organId,
  groupId,
  start,
  rows,
  startTime,
  endTime,
  keyword,
  download
}) {
  return request
    .get('/institutionAdmin/student/dataList', {
      params: {
        institution_id: organId,
        group_id: groupId,
        start,
        rows,
        start_time: startTime,
        end_time: endTime,
        keyword,
        download
      }
    })
    .then(result => {
      return result.data
    })
}
// 查询作业数据
function SearchHomework({
  organId,
  groupId,
  start,
  rows,
  startTime,
  endTime,
  taskType,
  taskStatus
}) {
  return request
    .get('/institutionAdmin/task/list', {
      params: {
        institution_id: organId,
        group_id: groupId,
        start,
        rows,
        start_time: startTime,
        end_time: endTime,
        task_type: taskType,
        task_status: taskStatus
      }
    })
    .then(result => {
      return result.data
    })
}
// 学生完成的作业详情
function StudentCompleteData({
  id,
  type
}) {
  return request
    .get('/institutionAdmin/task/studentCompleteData', {
      params: {
        task_id: id,
        task_type: type
      }
    })
    .then(result => {
      return result.data
    })
}
// 学生完成的作业内容
function TaskData({
  id,
  type
}) {
  return request
    .get('/institutionAdmin/task/info', {
      params: {
        task_id: id,
        task_type: type
      }
    })
    .then(result => {
      return result.data
    })
}

// 获取作业数量图表元数据
function GetHomeworkCountData({
  groupId,
  startTime,
  endTime,
  institutionId
}) {
  return request
    .get('institutionAdmin/institution/taskCompleteData', {
      params: {
        group_id: groupId,
        start_time: startTime,
        end_time: endTime,
        institution_id: institutionId
      }
    })
    .then(result => {
      return result.data
    })
}
// 获取作业完成率图表元数据
function GetHomeworkRatioData({
  groupId,
  startTime,
  endTime,
  institutionId
}) {
  return request
    .get('institutionAdmin/institution/taskCompleteRate', {
      params: {
        group_id: groupId,
        start_time: startTime,
        end_time: endTime,
        institution_id: institutionId
      }
    })
    .then(result => {
      return result.data
    })
}
// 获取作业平均分图表元数据
function GetHomeworkAvgData({
  groupId,
  startTime,
  endTime,
  institutionId
}) {
  return request
    .get('institutionAdmin/institution/taskScore', {
      params: {
        group_id: groupId,
        start_time: startTime,
        end_time: endTime,
        institution_id: institutionId
      }
    })
    .then(result => {
      return result.data
    })
}

// 获取机构班级下拉数据源
function GetGroupAndClass() {
  return request.get('institutionAdmin/institution/groups').then(result => {
    return result.data
  })
}
// 查询老师数据
function SearchTeacher({
  keyword,
  startT,
  rowsT,
  startTime,
  endTime
}) {
  return request
    .get('/institutionAdmin/teacher/dataList', {
      params: {
        keyword,
        start: startT,
        rows: rowsT,
        start_time: startTime,
        end_time: endTime
      }
    })
    .then(result => {
      return result.data
    })
}
// 查询老师手下班级数据
function SearchTeacherGroup({
  uid,
  keyword,
  startT,
  rowsT
}) {
  return request
    .get('/institutionAdmin/teacher/groupDataList', {
      params: {
        teacher_uid: uid,
        keyword,
        start: startT,
        rows: rowsT
      }
    })
    .then(result => {
      return result.data
    })
}
// 查询老师手下班级详情
function SearchGroupData({
  institutionId,
  id,
  keyword,
  startT,
  rowsT
}) {
  return request
    .get('/institutionAdmin/student/dataList', {
      params: {
        institution_id: institutionId,
        group_id: id,
        keyword,
        start: startT,
        rows: rowsT
      }
    })
    .then(result => {
      return result.data
    })
}
// 查询学生作业明细
function SearchWorkData({
  studentUid,
  id,
  keyword,
  start,
  rows,
  startData,
  endData
}) {
  return request
    .get('/institutionAdmin/task/studentTaskDetails', {
      params: {
        student_uid: studentUid,
        group_id: id,
        keyword,
        start,
        rows,
        start_time: startData,
        end_time: endData
      }
    })
    .then(result => {
      return result.data
    })
}
// 查询打卡明细
function SearchPunchData({
  status,
  keyword,
  start,
  rows,
  startData,
  endData
}) {
  return request
    .get('/institutionAdmin/punch/list', {
      params: {
        status,
        keyword,
        start,
        rows,
        start_time: startData,
        end_time: endData
      }
    })
    .then(result => {
      return result.data
    })
}
// 查询打卡明细
function SearchPunchInfo({
  punchId
}) {
  return request
    .get('/institutionAdmin/punch/info', {
      params: {
        punch_id: punchId
      }
    })
    .then(result => {
      return result.data
    })
}
// 查询打卡明细
function SearchGroupInfo({
  punchId,
  punchDate,
  groupId,
  start,
  rows
}) {
  return request
    .get('/institutionAdmin/punch/punchData', {
      params: {
        punch_id: punchId,
        punch_date: punchDate,
        punch_group_id: groupId,
        start,
        rows
      }
    })
    .then(result => {
      return result.data
    })
}

// 查询引流明细
function SearchInInfo({
  punchId
}) {
  return request
    .get('/institutionAdmin/punch/fromData', {
      params: {
        punch_id: punchId
      }
    })
    .then(result => {
      return result.data
    })
}

export default {
  GetOrgan,
  GetTeacherList,
  SearchStudent,
  GetHomeworkCountData,
  GetHomeworkRatioData,
  GetHomeworkAvgData,
  GetGroupAndClass,
  SearchHomework,
  StudentCompleteData,
  TaskData,
  SearchTeacher,
  SearchTeacherGroup,
  SearchGroupData,
  SearchWorkData,
  SearchPunchData,
  SearchPunchInfo,
  SearchGroupInfo,
  SearchInInfo
}
